import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useAuth } from "../provider/AuthContext";
import { ProtectedRoute } from "./ProtectedRoute";
import Main from "../Main";
import LoginPage from "../LoginPage";
import GoodPrices from "../GoodPrices";
import EnginePower from "../EnginePower";
import Parser from "../Parser";
import Dataflow from "../Dataflow";
import Requests from "../Requests";
import Upload from "../Upload";
import SearchCarBySpecPage from "../SearchCarBySpecPage";
import TimeMaster from "../TimeMaster";
import Settings from "../Settings";

const Routes = () => {
  const { token } = useAuth();

  // Define public routes accessible to all users
  // TimeMaster has its own login, so it does not need the app login.
  const routesForPublic = [
    {
      path: "/time-master",
      element: <TimeMaster />,
    },
  ];

  const routesForAuthenticatedOnly = [
    {
      path: "/",
      element: <ProtectedRoute />, // Wrap the component in ProtectedRoute
      children: [
        {
          path: "/",
          element: <Main />,
        },
        {
          path: "/good-prices",
          element: <GoodPrices />,
        },
        {
          path: "/engine-power",
          element: <EnginePower />,
        },
        {
          path: "/parser",
          element: <Parser />,
        },
        {
          path: "/dataflow",
          element: <Dataflow />,
        },
        {
          path: "/requests",
          element: <Requests />,
        },
        {
          path: "/upload",
          element: <Upload />,
        },
        {
          path: "/search-car-by-spec",
          element: <SearchCarBySpecPage />,
        },
        {
          path: "/settings",
          element: <Settings />,
        },
      ],
    },
  ];

  // Define routes accessible only to non-authenticated users
  const routesForNotAuthenticatedOnly = [
    {
      path: "/login",
      element: <LoginPage />,
    },
  ];

  // Combine and conditionally include routes based on authentication status
  const router = createBrowserRouter([
    ...routesForPublic,
    ...(!token ? routesForNotAuthenticatedOnly : []),
    ...routesForAuthenticatedOnly,
  ]);

  // Provide the router configuration using RouterProvider
  return <RouterProvider router={router} />;
};

export default Routes;
